import React, { JSX } from "react";
import { _aligeText, _colorText, _sizeHeading } from "../../core/core";
import "./title.css";

interface TitleProps {
  type?: _sizeHeading;
  is_h1?: boolean;
  color?: _colorText;
  alige?: _aligeText;
  children?: React.ReactNode;
}

const Title: React.FC<TitleProps> = ({
  type = _sizeHeading.h2,
  is_h1 = false,
  color = _colorText.black,
  alige = _aligeText.left,
  children,
  ...props
}) => {
  const renderTitle = (): JSX.Element => {
    const className = `${type} h-${color} h-${alige}`;
    if (is_h1 || type === _sizeHeading.h1) {
      return (
        <h1 className={className} {...props}>
          {children}
        </h1>
      );
    }
    if (type === _sizeHeading.h2 || type === _sizeHeading.h2_2) {
      return (
        <h2 className={className} {...props}>
          {children}
        </h2>
      );
    }
    if (type === _sizeHeading.h3) {
      return (
        <h3 className={className} {...props}>
          {children}
        </h3>
      );
    }
    // Default case
    return (
      <h2 className={className} {...props}>
        {children}
      </h2>
    );
  };

  return renderTitle();
};

export default Title;
